import { render, staticRenderFns } from "./SimulationToolbarSort.vue?vue&type=template&id=e72749b6&scoped=true"
import script from "./SimulationToolbarSort.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimulationToolbarSort.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SimulationToolbarSort.vue?vue&type=style&index=0&id=e72749b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@6.11.0_underscore@1.13.6_vue-template-compiler@2.7.14_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72749b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/.pnpm/vuetify-loader@1.7.3_vue-template-compiler@2.7.14_vuetify@2.7.1_webpack@5.89.0/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
